import React, {useState} from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';

import AppConfig from '../../domain/AppConfig';
import AppService from '../../service/AppService';
let appConfig:AppConfig = AppService.appConfig();

import {Button, Message} from '@aperza/ui';

import {useTranslation} from 'react-i18next';

const ClipYetLogin = (props) => {

  let {
    open,
    onClose,
  } = props;

  const {t} = useTranslation(['catalog']);

  let loginUrl = `${appConfig.aperzaIdHost}/login/${appConfig.serviceType}/?rp=header&path=${AppService.encodedPath()}`;

  return (
    <Modal
      show={open}
      onHide={onClose}
      size={'lg'}
      id="ClipYetLogin"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('catalog.clipYetLogin.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-4">{t('catalog.clipYetLogin.description')}</p>
        <div className="text-center pt-4 mb-3">
          <Button size="xxxl"
                  id={'submitInquiryButton'}
                  type={Button.TYPE_PRIMARY}
                  href={loginUrl}
          >
            <Message messageId={'clip.anonymous.link'}/>
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button size="xl" type={Button.TYPE_DEFAULT} wide={true} onClick={onClose}>{t('close')}</Button>
      </Modal.Footer>
    </Modal>
  )

};

ClipYetLogin.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default ClipYetLogin;
